export default __webpack_public_path__ + "static/media/File_Cloud.42561c37.png";